import React, { useEffect } from 'react';
// import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import CloseIcon from '@mui/icons-material/Close';
import { actions } from 'redux/actions';
import { Button } from '@mui/material';

export default ({
  show = false,
  message = '',
  onClose = (e) => e,
  type = 'error',
  position = {
    vertical: 'top',
    horizontal: 'right',
  },
}) => {
  const [open, setOpen] = React.useState(show);

  useEffect(() => {
    setOpen(show);
  }, [show]);

  function handleClose() {
    setOpen(false);
    actions.notification.clear();
    onClose();
  }

  return (
    <Snackbar
      anchorOrigin={position}
      open={open}
      autoHideDuration={3000}
      onClose={handleClose}
    >
      <SnackbarContent
        message={<span>{message}</span>}
        style={{ backgroundColor: type === 'error' ? '#d32f2f' : '#43a047' }}
        action={[
          <Button color="inherit" size="small" onClick={handleClose} key="close-icon">
            <CloseIcon />
          </Button>,
        ]}
      />
    </Snackbar>
  );
};
